import React, { useState, useEffect } from 'react';
import api from '../services/api';

// Concept-partijen + datums in Nieuwe Werkorder — wordt gekoppeld bij aanmaken
export default function PartijenBlok({ onPendingChange, afdelingen }) {
  const [onderaannemers, setOnderaannemers] = useState([]);
  const [partijen, setPartijen] = useState([]);
  const [datums, setDatums] = useState([]);
  const [nieuweDatum, setNieuweDatum] = useState('');
  const [type, setType] = useState('afdeling');
  const [keuzeId, setKeuzeId] = useState('');
  const [duurDagen, setDuurDagen] = useState(1);
  const [aanvangTijd, setAanvangTijd] = useState('');
  const [directVersturen, setDirectVersturen] = useState(false);
  const [opleverpunten, setOpleverpunten] = useState('');
  const [opleverTemplates, setOpleverTemplates] = useState([]);
  useEffect(() => { api.get('/werkorder-partijen/opleverpunt-templates').then(r => setOpleverTemplates(r.data.templates || [])).catch(() => {}); }, []);

  useEffect(() => {
    api.get('/onderaannemers').then(r => setOnderaannemers(r.data.onderaannemers || [])).catch(() => {});
  }, []);

  useEffect(() => {
    if (onPendingChange) onPendingChange({ partijen, datums, duur_dagen: duurDagen, aanvang_tijd: aanvangTijd, direct_versturen: directVersturen, opleverpunten });
  }, [partijen, datums, duurDagen, aanvangTijd, directVersturen, opleverpunten]); // eslint-disable-line

  const voegPartij = () => {
    if (!keuzeId) return;
    const id = parseInt(keuzeId);
    if (partijen.some(p => p.type === type && p.id === id)) return;
    const naam = type === 'afdeling'
      ? (afdelingen.find(a => a.id === id) || {}).naam
      : (onderaannemers.find(o => o.id === id) || {}).naam;
    setPartijen([...partijen, { type, id, naam: naam || '?' }]);
    setKeuzeId('');
  };

  const voegDatum = () => {
    if (!nieuweDatum || datums.includes(nieuweDatum)) return;
    setDatums([...datums, nieuweDatum].sort());
    setNieuweDatum('');
  };

  return (
    <div style={{ background: '#eff6ff', border: '1px dashed #93c5fd', borderRadius: '10px', padding: '14px', marginTop: '12px' }}>
      <div style={{ fontWeight: 700, color: '#1d4ed8', marginBottom: '4px' }}>🤝 Partijen ({partijen.length}) <span style={{ fontWeight: 400, fontSize: '12px', color: '#6b7280' }}>(concept — wordt gekoppeld bij Werkorder Aanmaken)</span></div>
      {partijen.length === 0 && <div style={{ fontSize: '13px', color: '#6b7280', fontStyle: 'italic', marginBottom: '8px' }}>Nog geen partijen gekoppeld.</div>}
      {partijen.map((p, i) => (
        <span key={i} style={{ display: 'inline-block', background: '#dbeafe', borderRadius: '8px', padding: '5px 10px', fontSize: '13px', marginRight: '6px', marginBottom: '6px' }}>
          {p.type === 'afdeling' ? '🏢' : '🏗️'} {p.naam}
          <button type="button" onClick={() => setPartijen(partijen.filter((_, x) => x !== i))} style={{ marginLeft: '6px', border: 'none', background: 'none', cursor: 'pointer', color: '#dc2626' }}>×</button>
        </span>
      ))}
      <div style={{ display: 'flex', gap: '8px', marginTop: '4px', marginBottom: '10px' }}>
        <select value={type} onChange={e => { setType(e.target.value); setKeuzeId(''); }} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
          <option value="afdeling">Afdeling</option>
          <option value="extern">Onderaannemer</option>
        </select>
        <select value={keuzeId} onChange={e => setKeuzeId(e.target.value)} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px', minWidth: '160px' }}>
          <option value="">— kies —</option>
          {type === 'afdeling'
            ? afdelingen.map(a => <option key={a.id} value={a.id}>{a.naam}</option>)
            : onderaannemers.map(o => <option key={o.id} value={o.id}>{o.naam}</option>)}
        </select>
        <button type="button" onClick={voegPartij} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 12px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>+ Partij</button>
      </div>
      {partijen.length > 0 && (
        <div>
          <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Voorsteldatums</div>
          {datums.map(d => (
            <span key={d} style={{ display: 'inline-block', background: '#dbeafe', borderRadius: '8px', padding: '5px 10px', fontSize: '13px', marginRight: '6px', marginBottom: '6px' }}>
              {new Date(d).toLocaleDateString('nl-NL')}
              <button type="button" onClick={() => setDatums(datums.filter(x => x !== d))} style={{ marginLeft: '6px', border: 'none', background: 'none', cursor: 'pointer', color: '#dc2626' }}>×</button>
            </span>
          ))}
          <div style={{ marginBottom: '10px' }}>
            <div style={{ fontSize: '13px', fontWeight: 600, marginBottom: '4px' }}>Opleverpunten voor externe partij(en) <span style={{ color: '#6b7280', fontWeight: 400 }}>(één per regel — monteur vinkt af bij afmelden)</span></div>
            {opleverTemplates.length > 0 && (
              <select value="" onChange={e => { const t = opleverTemplates.find(x => String(x.id) === e.target.value); if (t) setOpleverpunten(t.punten); }}
                style={{ marginBottom: '6px', border: '1px solid #d1d5db', borderRadius: '8px', padding: '6px 10px', fontSize: '13px' }}>
                <option value="">— kies template —</option>
                {opleverTemplates.map(t => <option key={t.id} value={t.id}>{t.naam}</option>)}
              </select>
            )}
            <textarea value={opleverpunten} onChange={e => setOpleverpunten(e.target.value)} rows={3}
              placeholder={"Terrein opgeruimd\nHekwerk teruggeplaatst\nFoto's gemaakt van het eindresultaat"}
              style={{ width: '100%', border: '1px solid #d1d5db', borderRadius: '8px', padding: '8px 10px', fontSize: '13px', boxSizing: 'border-box' }} />
          </div>
                    <label style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', marginBottom: '8px', color: '#1d4ed8', fontWeight: 600 }}>
            <input type="checkbox" checked={directVersturen} onChange={e => setDirectVersturen(e.target.checked)} />
            📧 Voorstel direct versturen naar onderaannemer(s) na aanmaken
          </label>
          <div style={{ display: 'flex', gap: '8px', marginTop: '4px' }}>
            <input type="date" value={nieuweDatum} onChange={e => setNieuweDatum(e.target.value)} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }} />
            <button type="button" onClick={voegDatum} style={{ background: '#2563eb', color: '#fff', border: 'none', borderRadius: '8px', padding: '6px 12px', fontWeight: 600, cursor: 'pointer', fontSize: '13px' }}>+ Datum</button>
            <span style={{ fontSize: '13px', marginLeft: '8px' }}>Duur:</span>
            <input type="number" min="1" max="30" value={duurDagen} onChange={e => setDuurDagen(Math.max(1, parseInt(e.target.value) || 1))} style={{ width: '50px', padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }} />
            <span style={{ fontSize: '13px' }}>{duurDagen === 1 ? 'dag' : 'dagen'}</span>
            <span style={{ fontSize: '13px', marginLeft: '8px' }}>Aanvang:</span>
            <select value={(aanvangTijd || '').split(':')[0] || ''} onChange={e => setAanvangTijd(e.target.value === '' ? '' : e.target.value + ':' + ((aanvangTijd || '').split(':')[1] || '00'))} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
              <option value="">--</option>
              {Array.from({length: 24}, (_, i) => String(i).padStart(2, '0')).map(u => <option key={u} value={u}>{u}</option>)}
            </select>
            <span style={{ fontSize: '13px' }}>:</span>
            <select value={(aanvangTijd || '').split(':')[1] || '00'} onChange={e => { const u = (aanvangTijd || '').split(':')[0]; if (u) setAanvangTijd(u + ':' + e.target.value); }} style={{ padding: '6px', borderRadius: '8px', border: '1px solid #d1d5db', fontSize: '13px' }}>
              {['00','15','30','45'].map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </div>
        </div>
      )}
    </div>
  );
}
